
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/account/details",
      function () {
        return require("private-next-pages/[locale]/account/details.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/account/details"])
      });
    }
  